window.addEventListener('DOMContentLoaded', () => {

  if (!document.querySelector('.styles2202.sustainability')) return;

  // 記事パネルの生成・絞り込み
  (function() {
    const template = document.querySelector('#sustainabilityArticleTemplate');
    if (!template) return;

    // 記事のパネルを生成
    function populateArticles(articles) {
      const inner = document.querySelector('.sustainability-article-section__inner');
      const summary = document.querySelector('.sustainability-article-summary');
      const nodes = new DocumentFragment();
      nodes.append(summary);

      articles.forEach(article => {
        const node = template.content.cloneNode(true);
        const container = node.querySelector('.sustainability-article');
        container.classList.add(`-${article.type}`);
        const img = node.querySelector('.sustainability-article__image img');
        img.src = article.image;
        img.alt = article.title.replace(/(<([^>]+)>)/gi, '');
        const title = node.querySelector('.sustainability-article__title');
        title.innerHTML = article.title;
        const link = node.querySelector('.sustainability-article__link');
        link.href = article.link;
        nodes.append(node);
      });

      inner.replaceChildren([]);
      inner.appendChild(nodes);
    }

    function selectArticleType(button) {
      if (button.classList.contains('-selected')) return;

      const buttons = document.querySelectorAll('.sustainability-article-summary__button');
      buttons.forEach(button => button.classList.remove('-selected'));
      button.classList.add('-selected');

      const type = button.dataset.type;
      let articles = document.querySelectorAll('.sustainability-article');
      articles.forEach(article => article.classList.remove('-showAnimation'));
      setTimeout(() => {
        articles.forEach(article => article.classList.remove('-show'));
        if (type) {
          articles = Array.from(articles).filter(article => article.classList.contains(`-${type}`))
        }
        articles.forEach(article => article.classList.add('-show'));
        setTimeout(() => {
          articles.forEach(article => article.classList.add('-showAnimation'));
        });
      }, 200);
    }

    // 絞り込みボタンクリック時の動作
    const buttons = document.querySelectorAll('.sustainability-article-summary__button');
    buttons.forEach(button => {
      button.addEventListener('click', () => {
        selectArticleType(button);
      });
    });

    // 初期表示
    populateArticles(window.sustainabilityArticles);
    selectArticleType(buttons[0]);
  })();

  // 画面幅を変更したときの記事パネルの列数を変更する
  (function() {
    const tileSize = 240;
    const tileGap = 20;
    const inner = document.querySelector('.sustainability-article-section__inner');
    const observer = new ResizeObserver(calcColumn);
    observer.observe(document.body);
    calcColumn();

    function calcColumn() {
      let column = '';
      for (let i = 5; i >= 2; i--) {
        if (tileSize * i + tileGap * (i - 1) <= document.body.clientWidth) {
          column = i;
          break;
        }
      }
      inner.dataset.column = column;
    }
  })();

});